"use strict";
exports.__esModule = true;
exports.WebshopIntegration = exports.WebshopProductCatalog = exports.WebshopOrder = exports.DesignerCatalogReference = void 0;
var Design_1 = require("./Design");
var core_common_logic_1 = require("@jewelutions/core-common-logic");
var DesignerCatalogReference = /** @class */ (function () {
    function DesignerCatalogReference() {
    }
    DesignerCatalogReference.identical = function (first, second) {
        return (first.catalogId === second.catalogId &&
            first.productCollectionId === second.productCollectionId &&
            first.productId === second.productId &&
            first.accessoryVariantId === second.accessoryVariantId &&
            first.pieceVariantId === second.pieceVariantId);
    };
    return DesignerCatalogReference;
}());
exports.DesignerCatalogReference = DesignerCatalogReference;
var WebshopOrder = /** @class */ (function () {
    function WebshopOrder() {
    }
    WebshopOrder.decodeItemCustomisation = function (input) {
        return JSON.parse(core_common_logic_1.CommonLogic.Base64.decode(input));
    };
    WebshopOrder.encodeItemCustomisation = function (itemCustomisation) {
        return core_common_logic_1.CommonLogic.Base64.encode(JSON.stringify(itemCustomisation));
    };
    WebshopOrder.orderLineCustomAttributes = {
        /** This must start with underscores as Shopify expects it. */
        designSessionState: '__designSessionState'
    };
    return WebshopOrder;
}());
exports.WebshopOrder = WebshopOrder;
var WebshopProductCatalog = /** @class */ (function () {
    function WebshopProductCatalog() {
    }
    WebshopProductCatalog.shopCollectionTags = {
        platformNamespaceKey: 'com.jewelutions',
        managedByJewelutionsKey: 'managedByJewelutions'
    };
    WebshopProductCatalog.productVariantTags = {
        platformNamespaceKey: 'com.jewelutions',
        designerCatalogReferenceKey: 'designerCatalogReference'
    };
    return WebshopProductCatalog;
}());
exports.WebshopProductCatalog = WebshopProductCatalog;
var WebshopIntegration = /** @class */ (function () {
    function WebshopIntegration() {
    }
    WebshopIntegration.defaultPreferences = {
        imagesPerProductVariant: 1,
        requiresShipping: true,
        taxable: true,
        shopCollectionTitle: 'Jewelutions',
        shopCollectionDescriptionHtml: 'Jewelutions customisable products',
        productType: 'personalised_jewelry',
        /* This template suffix means that we need a product.jewelutions in the shop. */
        templateSuffix: 'jewelutions',
        material: Design_1.MaterialType.SILVER,
        pieceStonesPlacementType: Design_1.StonesPlacementType.FULL_STONES,
        materialDefaultPlating: new Map([[Design_1.MaterialType.SILVER, Design_1.PlatingType.RHODIUM]])
    };
    return WebshopIntegration;
}());
exports.WebshopIntegration = WebshopIntegration;
